let id = 0;
const getID = (symbol) => {
    const symbolAny = symbol;
    if (symbolAny.id == undefined && symbolAny.__id === undefined) {
        id += 1;
        const symbolID = `c${id}`;
        symbolAny.__id = symbolID;
        return symbolID;
    }
    return symbolAny.id || symbolAny.__id;
};
export const symbolKey = (symbol) => `${getID(symbol)}`;

//# sourceMappingURL=symbolKey.js.map
